var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.disabled)?_c('transition',{attrs:{"css":false},on:{"enter":_vm.expandAnimEnter,"leave":_vm.expandAnimLeave}},[_vm._t("default")],2):_c('transition',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }